import type { ReactNode } from 'react'

interface FiltersBarProps {
  children: ReactNode
}

export function FiltersBar({ children }: FiltersBarProps) {
  return (
    <div className="flex w-full items-center justify-between rounded-lg bg-brand-grayscale-2 px-4 py-2.5">
      {children}
    </div>
  )
}
